import { Item } from '@zebra-fed/zds-react-desktop';

const baseButtonStyle = {
  minWidth: 110,
  height: 36,
  fontSize: 16,
  fontWeight: 500,
  borderRadius: 4,
  cursor: 'pointer',
  alignItems: 'center',
  justifyContent: 'center',
  marginLeft: '12px'
};

export const createPrimaryItem = ({ onClick, children, disabled, style = {} }) => (
  <Item
    type="button"
    style={{
      ...baseButtonStyle,
      backgroundColor: '#0073E6',
      color: 'white',
      border: 'none',
      opacity: disabled ? 0.6 : 1,
      cursor: disabled ? 'not-allowed' : 'pointer',
      ...style,
    }}
    onClick={disabled ? undefined : onClick}
    disabled={disabled}
  >
    {children}
  </Item>
);

export const createGhostItem = ({ onClick, children, disabled, style = {} }) => (
  <Item
    type="button"
    style={{
      ...baseButtonStyle,
      backgroundColor: '#757575',
      color: 'white',
      border: 'none',
      opacity: disabled ? 0.6 : 1,
      cursor: disabled ? 'not-allowed' : 'pointer',
      ...style,
    }}
    onClick={disabled ? undefined : onClick}
    disabled={disabled}
  >
    {children}
  </Item>
);

export const createSecondaryItem = ({ onClick, children, disabled, style = {} }) => (
  <Item
    type="button"
    style={{
      ...baseButtonStyle,
      backgroundColor: 'white',
      color: '#0073E6',
      border: '1px solid #0073E6',
      opacity: disabled ? 0.6 : 1,
      cursor: disabled ? 'not-allowed' : 'pointer',
      ...style,
    }}
    onClick={disabled ? undefined : onClick}
    disabled={disabled}
  >
    {children}
  </Item>
);

export const createDangerItem = ({ onClick, children, disabled, style = {} }) => (
  <Item
    type="button"
    style={{
      ...baseButtonStyle,
      backgroundColor: '#D70015',
      color: 'white',
      border: 'none',
      opacity: disabled ? 0.6 : 1,
      cursor: disabled ? 'not-allowed' : 'pointer',
      '&:hover': {
        backgroundColor: '#FF1744',
      },
      ...style,
    }}
    onClick={disabled ? undefined : onClick}
    disabled={disabled}
  >
    {children}
  </Item>
);